import { NgModule } from '@angular/core';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import {
  materialAlarmOnIcon,
  materialAttachMoneyIcon,
  materialDownloadIcon,
  materialUploadIcon,
  materialMenuIcon,
  materialSearchIcon,
  materialEditIcon,
  materialDeleteIcon,
  materialPersonAddIcon,
  materialChevronLeftIcon,
  materialChevronRightIcon,
  materialFileDownloadIcon,
  materialPersonIcon,
  materialMoreVertIcon,
  materialPhoneIcon,
  materialEmailIcon,
  materialChatIcon,
  materialCallIcon,
  materialCallEndIcon,
  materialPhoneEnabledIcon,
  materialSendIcon,
  materialCloseIcon,
  materialArrowDropUpIcon,
  materialArrowDropDownIcon,
  materialKeyboardArrowDownIcon,
  materialKeyboardArrowUpIcon,
  materialAddAlertIcon,
  materialCalendarMonthIcon,
  materialStickyNote2Icon,
  materialAccessTimeIcon,
  materialItkLoadingIcon,
  materialIosShareIcon,
  materialItkRxIcon,
  materialItkCrossIcon,
  materialItkQuestionCircleIcon,
  materialItkPlanSelectIcon,
  materialLightbulbIcon,
  materialItkLightbulbIcon,
  materialItkDvhEarIcon,
  materialItkDvhToothIcon,
  materialItkDvhNetworkIcon,
  materialItkSubscriptionAgencyBundleIcon,
  materialItkSubscriptionIndividualBundleIcon,
  materialItkInfoIcon,
  materialItkCcAmexIcon,
  materialItkCcVisaIcon,
  materialItkCcDiscoverIcon,
  materialItkCcMastercardIcon,
  materialHelpIcon,
  materialInfoIcon,
  materialItkDvhEyeIcon,
  materialDragIndicatorIcon,
  materialAddBoxIcon,
  materialExpandLessIcon,
  materialExpandMoreIcon,
  materialOpenInNewIcon,
  materialNoteAddIcon,
  materialBookIcon,
  materialVolumeUpIcon,
  materialVolumeOffIcon,
  materialMicIcon,
  materialMicOffIcon,
  materialItkLogoMarkIcon,
  materialAddCircleIcon,
  materialAddIcon,
  materialForwardIcon,
  materialSkipNextIcon,
  materialRedoIcon,
  materialCheckCircleIcon,
} from './svg/icons.svg';

export const appIcons = [
  materialItkDvhEyeIcon,
  materialAttachMoneyIcon,
  materialMicIcon,
  materialMicOffIcon,
  materialVolumeUpIcon,
  materialVolumeOffIcon,
  materialItkCcAmexIcon,
  materialItkCcVisaIcon,
  materialCheckCircleIcon,
  materialMenuIcon,
  materialCallIcon,
  materialForwardIcon,
  materialSkipNextIcon,
  materialCallEndIcon,
  materialPhoneEnabledIcon,
  materialAlarmOnIcon,
  materialItkCcDiscoverIcon,
  materialRedoIcon,
  materialItkCcMastercardIcon,
  materialItkRxIcon,
  materialUploadIcon,
  materialItkCrossIcon,
  materialItkDvhEarIcon,
  materialItkDvhToothIcon,
  materialItkDvhNetworkIcon,
  materialItkSubscriptionAgencyBundleIcon,
  materialItkSubscriptionIndividualBundleIcon,
  materialItkQuestionCircleIcon,
  materialItkPlanSelectIcon,
  materialItkInfoIcon,
  materialLightbulbIcon,
  materialInfoIcon,
  materialHelpIcon,
  materialItkLightbulbIcon,
  materialSearchIcon,
  materialPersonIcon,
  materialEditIcon,
  materialDeleteIcon,
  materialPersonAddIcon,
  materialChevronLeftIcon,
  materialChevronRightIcon,
  materialFileDownloadIcon,
  materialDownloadIcon,
  materialMoreVertIcon,
  materialPhoneIcon,
  materialEmailIcon,
  materialChatIcon,
  materialSendIcon,
  materialCloseIcon,
  materialArrowDropUpIcon,
  materialArrowDropDownIcon,
  materialKeyboardArrowDownIcon,
  materialKeyboardArrowUpIcon,
  materialAddAlertIcon,
  materialCalendarMonthIcon,
  materialStickyNote2Icon,
  materialAccessTimeIcon,
  materialItkLoadingIcon,
  materialIosShareIcon,
  materialDragIndicatorIcon,
  materialAddBoxIcon,
  materialExpandLessIcon,
  materialExpandMoreIcon,
  materialOpenInNewIcon,
  materialNoteAddIcon,
  materialAddIcon,
  materialBookIcon,
  materialItkLogoMarkIcon,
  materialAddCircleIcon,
];

@NgModule({
  imports: [SvgIconComponent],
  exports: [SvgIconComponent],
  providers: [provideSvgIcons(appIcons)],
})
export class ItkIconsLogosModule {}
